module.exports = __webpack_public_path__ + "static/media/431121135_932736932194728_2398425783514780745_n.ff14fe83.jpg";